import styled from 'styled-components';
import { OptionValueType } from './CommonMessageHeaderPopoverList';
import UIIcon from 'UIComponents/icon/UIIcon';
import { copyWithFloatingMessage } from '../util/copyToClipboard';
import * as colors from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledButton = styled.button.withConfig({
  displayName: "CommonMessageHeaderPopoverListItemDescription__StyledButton",
  componentId: "sc-11lnzr6-0"
})(["border:unset;background:unset;width:20px;height:20px;border-radius:4px;color:", ";margin-left:8px;padding:0px;&:hover{background:", ";}&:active{background:", ";}"], colors.EERIE, colors.GYPSUM, colors.BATTLESHIP);
const CommonMessageHeaderPopoverListItemDescription = ({
  name,
  value,
  valueType,
  copiableValue
}) => {
  const WrappingDatum = styled.div.withConfig({
    displayName: "CommonMessageHeaderPopoverListItemDescription__WrappingDatum",
    componentId: "sc-11lnzr6-1"
  })(["overflow-wrap:break-word;"]);
  let copyMessages;
  switch (valueType) {
    case OptionValueType.Email:
      {
        copyMessages = {
          copy: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `conversations-inbox-message-history.common-message.popover.copyEmail`
          }),
          copied: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `conversations-inbox-message-history.common-message.popover.copiedEmail`
          })
        };
        break;
      }
    case OptionValueType.PhoneNumber:
      {
        copyMessages = {
          copy: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `conversations-inbox-message-history.common-message.popover.copyPhoneNumber`
          }),
          copied: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `conversations-inbox-message-history.common-message.popover.copiedPhoneNumber`
          })
        };
        break;
      }
    default:
      {
        copyMessages = {
          copy: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `conversations-inbox-message-history.common-message.popover.copy`
          }),
          copied: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `conversations-inbox-message-history.common-message.popover.copied`
          })
        };
        break;
      }
  }
  return /*#__PURE__*/_jsxs(WrappingDatum, {
    children: [name && /*#__PURE__*/_jsxs("b", {
      children: [name, " "]
    }), value, copiableValue ? /*#__PURE__*/_jsx(UITooltip, {
      title: copyMessages.copy,
      children: /*#__PURE__*/_jsx(StyledButton, {
        onClick: () => {
          copyWithFloatingMessage(copiableValue, copyMessages.copied);
        },
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: 'duplicate',
          size: 14
        })
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};
CommonMessageHeaderPopoverListItemDescription.displayName = 'CommonMessageHeaderPopoverListItemDescription';
export default CommonMessageHeaderPopoverListItemDescription;